import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { Subscription } from 'rxjs';
import {
  ContextOption,
  WorkContext,
  WorkContextService,
} from '../../../service/admin/work-context.service';

@Component({
  selector: 'app-work-context-bar',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownModule],
  templateUrl: './work-context-bar.component.html',
  styleUrl: './work-context-bar.component.scss',
})
export class WorkContextBarComponent implements OnInit, OnDestroy {
  /** Compact inline layout for top toolbars (e.g. prescriptions chrome). */
  @Input() compact = false;

  context: WorkContext = {
    clinicId: null,
    doctorId: null,
    clinicName: '',
    doctorName: '',
  };

  clinicOptions: ContextOption[] = [];
  doctorOptions: ContextOption[] = [];

  draftClinicId: number | null = null;
  draftDoctorId: number | null = null;
  isEditing = false;

  private subscription = new Subscription();

  constructor(private workContext: WorkContextService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.workContext.ensureOptionsLoaded().subscribe(() => {
        this.clinicOptions = this.workContext.getClinics();
        this.doctorOptions = this.workContext.getDoctors();
      }),
    );

    this.subscription.add(
      this.workContext.context$.subscribe((ctx) => {
        this.context = ctx;
        if (!this.isEditing) {
          this.draftClinicId = ctx.clinicId;
          this.draftDoctorId = ctx.doctorId;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get isComplete(): boolean {
    return this.context.clinicId != null && this.context.doctorId != null;
  }

  get summaryLabel(): string {
    if (!this.isComplete) {
      return 'Select clinic and doctor to begin';
    }
    return `${this.context.clinicName || 'Clinic'} · ${this.context.doctorName || 'Doctor'}`;
  }

  openEditor(): void {
    this.draftClinicId = this.context.clinicId;
    this.draftDoctorId = this.context.doctorId;
    this.isEditing = true;
  }

  closeEditor(): void {
    this.draftClinicId = this.context.clinicId;
    this.draftDoctorId = this.context.doctorId;
    this.isEditing = false;
  }

  applyDraft(): void {
    if (this.draftClinicId == null || this.draftDoctorId == null) {
      return;
    }
    this.workContext.setContext(this.draftClinicId, this.draftDoctorId);
    this.isEditing = false;
  }

  onDraftChange(): void {
    if (this.draftClinicId != null && this.draftDoctorId != null) {
      this.applyDraft();
    }
  }
}
